{
  "dashboard": {
    "tabs": {
      "addTabDialog": {
        "title": "Add tab",
        "selectDashboard": "Select dashboard",
        "dashboard": "Dashboard",
        "name": "Name"
      }
    },
    "access": {
      "missingDashboardAccess": "One of dashboards was removed due to changed access settings"
    },
    "NewWidget": {
      "widget": "Widget",
      "new": "New",
      "existing": "Existing"
    },
    "dashboardModal": {
      "title": "Create widget"
    },
    "CreateDashboard": {
      "title": "Display name",
      "name": "Name",
      "tql": "TQL query",
      "ciTypeBindings": "CI type bindings",
      "ciTypeBindingsHint": "Select a TQL node for each CI type to open this dashboard filtered to the CI.",
      "ciTypeBindingNode": "TQL node",
      "ciTypeBindingNodePlaceholder": "Open without a CI filter",
      "ciTypeBindingInherited": "inherits",
      "ciTypeBindingDescendants_one": "+ {{count}} descendant",
      "ciTypeBindingDescendants_other": "+ {{count}} descendants",
      "ciTypeBindingNoDescendants": "no descendants",
      "privacy": "Privacy",
      "private": "Private",
      "general": "General",
      "template": "Template",
      "time": "Time setting",
      "interval": "Interval",
      "refresh": "Refresh"
    },
    "CreateWidget": {
      "PreviewBlock": {
        "title": "Select Widget and data type to display"
      },
      "DataTypeSelect": {
        "label": "Data type",
        "placeholder": "Select data type"
      },
      "HiSelect": {
        "hiType": "Hi type",
        "hi": "Hi",
        "ciLabel": "CI",
        "hiLabel": "indicator"
      },
      "MetricSelect": {
        "metric": "Metric",
        "metricQuery": "Query {{index}}"
      },
      "SourceBlock": {
        "title": "Data source"
      }
    },
    "CreateTabDialog": {
      "title": "Add tab"
    },
    "SelectFromDashboardList": {
      "create": "Create Dashboard",
      "select": "Select Dashboard",
      "label": "Dashboard"
    },
    "CreateDashboardDialog": {
      "create": "Create dashboard",
      "label": "Dashboard"
    },
    "timeRange": {
      "absolute": "Absolute time range",
      "relative": "Relative time range"
    },
    "timeInterval": {
      "typeError": "Incorrect data types in fields",
      "validationError": "The From field must be less than the To field",
      "absolute": "Absolute time range",
      "relatively": "Relative time ranges",
      "from": "From",
      "to": "To",
      "5m": "last 5 minutes",
      "15m": "last 15 minutes",
      "30m": "last 30 minutes",
      "1h": "last 1 hour",
      "3h": "last 3 hours",
      "6h": "last 6 hours",
      "12h": "last 12 hours",
      "1d": "last day",
      "2d": "last 2 days",
      "5d": "last 5 days",
      "1week": "last 7 week",
      "month": "last month"
    }
  },
  "dashboardPage": {
    "title": "Dashboard registry",
    "columns": {
      "id": "Id",
      "title": "Name",
      "name": "System name",
      "tags": "Tags",
      "query": "Query",
      "isPrivate": {
        "title": "Privacy",
        "private": "private",
        "general": "general"
      },
      "deleteTitle": "Deleting this dashboard might delete existing tabs. Proceed?",
      "action": "Action"
    },
    "addDashboardTitle": "Adding a dashboard"
  },
  "dataType": {
    "hi": "hi",
    "metric": "metric",
    "newMetric": "Line graph",
    "events": "events",
    "attributes": "attributes",
    "graph": "graph"
  },
  "options": {
    "addGrid": "Add grid",
    "settings": "Dashboard setting",
    "interval": "Interval",
    "refresh": {
      "refresh": "Refresh",
      "refreshInterval": "Refresh interval"
    },
    "fullscreen": "Fullscreen"
  },
  "errors": {
    "CITree": {
      "setDashboard": "Set dashboard to selected CIT",
      "selectCIT": "Select CIT"
    }
  }
}
